module.exports = __webpack_public_path__ + "media/stop-3.e41316f6.mp3";